import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue";
const _hoisted_1 = { class: "text-black" };
const _hoisted_2 = { class: "text-end" };
const _hoisted_3 = { class: "text-end" };
import { ref, computed } from "vue";
import gql from "fraql";
import AppFormDialog from "@/components/elements/AppFormDialog.vue";
import { useQuery } from "@vue/apollo-composable";
import AppShowEventDetails from "@AppShows/event/AppShowEventDetails.vue";
import { groupBy, clone } from "lodash-es";
import { injectAppFederation } from "@/composables/injections";
import AppShowPersonEventStaffFunctionStatusEdit from "@AppShows/AppShowPersonEventStaffFunctionStatusEdit.vue";
import AppTableHeader from "@elements/table/AppTableHeader.vue";
import AppTable from "@elements/table/AppTable.vue";
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: "PersonEventStaffListDialog"
    },
    __name: 'PersonEventStaffListDialog',
    props: {
        eventIds: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const { appFederation } = injectAppFederation();
        const dialog = ref(false);
        const initLoading = computed(() => eventLoading.value || loading.value);
        function openForm() {
            dialog.value = true;
        }
        __expose({ openForm });
        const event = ref();
        const personEventStaffFunctions = ref([]);
        const { onResult: onEventResult, loading: eventLoading } = useQuery(gql `
    query fetchEventForPersonEventStaffFunctionsList(
      $eventId: ID!
    ) {
      event(id: $eventId) {
        id
        ${AppShowEventDetails.fragments.event}
      }
    }
  `, () => ({
            eventId: props.eventIds[0]
        }), () => ({
            enabled: dialog.value && props.eventIds.length == 1,
            fetchPolicy: "cache-first"
        }));
        onEventResult(({ loading, data }) => {
            if (loading)
                return;
            event.value = data.event;
        });
        const { onResult, loading } = useQuery(gql `
    query fetchPersonEventStaffFunctionsOnEvent(
      $eventIds: [ID!]
    ) {
      personEventStaffFunctions(eventIds: $eventIds) {
        id
        status
        ${AppShowPersonEventStaffFunctionStatusEdit.fragments.personEventStaffFunctionFields}
        person {
          id
          name
        }
        eventStaffFunction {
          id
          name
          startDate
        }
      }
    }
  `, () => ({
            eventIds: props.eventIds
        }), () => ({
            enabled: dialog.value
        }));
        onResult(({ loading, data }) => {
            if (loading)
                return;
            personEventStaffFunctions.value = data.personEventStaffFunctions;
        });
        const compare = new Intl.Collator(appFederation.language).compare;
        const grouped = computed(() => {
            const funcs = clone(personEventStaffFunctions.value ?? []).sort((a, b) => {
                const aDate = new Date(a.eventStaffFunction.startDate).getTime();
                const bDate = new Date(b.eventStaffFunction.startDate).getTime();
                return aDate - bDate;
            });
            return Object.entries(groupBy(funcs, "eventStaffFunction.startDate")).map(arr => {
                arr[1] = arr[1].sort((a, b) => compare(a.person.name, b.person.name));
                return arr;
            });
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createBlock(AppFormDialog, {
                modelValue: dialog.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((dialog).value = $event)),
                "init-form-loading": initLoading.value,
                "dialog-props": {
                    id: 'personEventStaffListDialog'
                }
            }, {
                header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("events:personEventStaffFunctionsList.button", "Show list of candidate")), 1)
                ]),
                actions: _withCtx(({ cancelBtnAttrs }) => [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(cancelBtnAttrs)), {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("common:button.cancel", "Cancel")), 1)
                            ]),
                            _: 2
                        }, 1040)
                    ])
                ]),
                default: _withCtx(() => [
                    (event.value)
                        ? (_openBlock(), _createBlock(AppShowEventDetails, {
                            key: 0,
                            event: event.value,
                            "show-logo": ""
                        }, null, 8, ["event"]))
                        : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grouped.value, ([day, staffs]) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: day }, [
                            _createVNode(AppTableHeader, {
                                "custom-color": "#d9d9d9",
                                "single-col": ""
                            }, {
                                left: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$dayjs(day).format("DD MMMM | dddd")), 1)
                                ]),
                                _: 2
                            }, 1024),
                            _createVNode(AppTable, {
                                items: staffs,
                                class: "mb-10"
                            }, {
                                colgroup: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createElementVNode("colgroup", null, [
                                        _createElementVNode("col", { style: { "width": "220px" } }),
                                        _createElementVNode("col"),
                                        _createElementVNode("col", { style: { "width": "0px" } })
                                    ], -1)
                                ])),
                                items: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staffs, (staff) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: staff.id
                                        }, [
                                            _createElementVNode("td", null, _toDisplayString(staff.person.name), 1),
                                            _createElementVNode("td", null, _toDisplayString(staff.eventStaffFunction.name), 1),
                                            _createElementVNode("td", _hoisted_2, [
                                                _createVNode(AppShowPersonEventStaffFunctionStatusEdit, {
                                                    "person-event-staff-function": staff,
                                                    "teleport-edit-target": "#personEventStaffListDialog .v-overlay__content"
                                                }, null, 8, ["person-event-staff-function"])
                                            ])
                                        ]));
                                    }), 128))
                                ]),
                                _: 2
                            }, 1032, ["items"])
                        ], 64));
                    }), 128))
                ]),
                _: 1,
                __: [2]
            }, 8, ["modelValue", "init-form-loading"]));
        };
    }
});
